/**
 * 
 * @param {laterTime}  过去的时间
 * @returns 计算过去到现在的年份方便select选择
 */
export function getlaterYear (laterTime = '2019') {
  let yearList = []
  let laterDate = new Date(laterTime)
  let lateYear = laterDate.getFullYear()
  let date = new Date()
  let y = date.getFullYear()
  for (let i = lateYear; i <= y; i++) {
    let obj = {
      label: '',
      id: -1,
      name: ''
    }
    obj.label = i
    obj.id = i
    obj.name = i
    yearList.push(obj)
  }
  yearList.unshift({
    label: -1,
    id: -1,
    name: '不限'
  })
  return yearList
}


// WEBPACK FOOTER //
// ./src/jiulongpo/utils/DateTime.js